var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.25V6.75C13.5 4.62868 13.5 3.56802 12.841 2.90901C12.1819 2.25 11.1213 2.25 9 2.25H6C3.87868 2.25 2.81802 2.25 2.15901 2.90901C1.5 3.56802 1.5 4.62868 1.5 6.75V11.25C1.5 13.3713 1.5 14.4319 2.15901 15.091C2.81802 15.75 3.87868 15.75 6 15.75H15",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6H10.5",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9H10.5",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12H7.5",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6H14.25C15.3106 6 15.841 6 16.1705 6.3295C16.5 6.65901 16.5 7.18934 16.5 8.25V14.25C16.5 15.0784 15.8284 15.75 15 15.75C14.1716 15.75 13.5 15.0784 13.5 14.25V6Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteNewsIcon);
export default __webpack_public_path__ + "static/media/white-news-icon.252878d7d4aab99700224eea59869bce.svg";
export { ForwardRef as ReactComponent };